export default __webpack_public_path__ + "static/laddition-a69622a16f641da168a1329ce22356bb.png";